import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigApiService } from '../services/config-api.service';
import { url } from 'inspector';

@Injectable()
export class SubscriptionInterceptor implements HttpInterceptor {
  
  constructor(
    private configService: ConfigApiService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let params = this.configService.getParams();
    let urlParams = `?${Object.entries(params).map(([key, value]) => `${key}=${value}`).join('&')}`;
    let subId = params.project;
    let apiKey = params.key;

    let subReq = request.clone({
        headers: request.headers.set('subscription-id', subId).set('X-Api-key', apiKey),
        url: request.url + urlParams
    });

    return next.handle(subReq);
  }
}
